export default __webpack_public_path__ + "static/media/arrow-left.76cc39c5.svg";